import { LitElement, html, css } from 'lit'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'

class Highlight extends LitElement {
  static styles = css`
    :host {
      display: block;
    }

    .wrapper {
      position: relative;
      display: block;
    }

    .text {
      color: var(--highlight-color);
      position: relative;
      z-index: 2;
    }

    .ghost {
      position: absolute;
      top: 0.13em;
      bottom: 0;
      z-index: 1;
      user-select: none;
    }

    .left .ghost.before {
      left: 0.3em;
      right: -0.3em;
    }

    .left .ghost.after {
      left: -0.3em;
      right: 0.3em;
    }

    .right .ghost.before {
      right: 0.3em;
      left: -0.3em;
    }

    .right .ghost.after {
      right: -0.3em;
      left: 0.3em;
    }

    .ghost__inner {
      display: inline;
      transition: all 200ms ease-in-out;
      background: var(--highlight);
      color: transparent;
      padding: .3em 0 0;
    }

    .hover .ghost {
      transform: scaleX(0);
      transition: transform 150ms ease-in-out;
      transform-origin: 0;
    }

    .hover.active .ghost,
    :host(:hover) .hover .ghost {
      transform: scaleX(1);
    }
  `

  static properties = {
    hover: { type: Boolean },
    active: { type: Boolean }
  }

  constructor() {
    super()

    this.hover = false
    this.active = false

    const computedStyle = window.getComputedStyle(this)
    this._align =
      computedStyle.getPropertyValue('text-align') === 'right'
        ? 'right'
        : 'left'
  }

  firstUpdated() {
    const parentAnchor = this.closest('a');
    if(parentAnchor) {
      this.closest('a').addEventListener('mouseenter', () => {
        this.active = true
      })
      this.closest('a').addEventListener('mouseleave', () => {
        this.active = false
      })
    }
  }

  render() {
    return html`
      <span class="wrapper ${this._align}${this.hover ? ' hover' : ''}${this.active ? ' active' : ' inactive'}">
        <span class="text"><slot></slot></span>
        <span class="ghost before" aria-hidden="true">
          <span class="ghost__inner">${unsafeHTML(this.innerHTML)}</span>
        </span>
        <span class="ghost after" aria-hidden="true">
          <span class="ghost__inner">${unsafeHTML(this.innerHTML)}</span>
        </span>
      </span>
    `
  }
}
customElements.define('highlight-text', Highlight)
